import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from '@mui/material';
import { routineCsvHeaders } from 'common/constants/routineCsvHeader';
import React from 'react';
import { CSVLink } from 'react-csv';
import convertCsvFormat from 'utils/convertCsvFormat';
import { RootStyle } from './style';

interface IProps {
  error: IError;
  routines: any;
  fileName: string;
  clearError: () => void;
  challengeId: string | undefined
}

export function RoutineErrorModal({
  error,
  routines,
  fileName,
  clearError,
  challengeId
}: IProps) {
  const handleCloseModal = () => {
    clearError();
  };

  return (
    <Dialog
      keepMounted
      open={error.isOpen}
      onClose={handleCloseModal}
      aria-labelledby='keep-mounted-modal-title'
      aria-describedby='keep-mounted-modal-description'
    >
      <DialogContent>
        <Typography variant='h5' color='error'>
          Status: {error.status}
        </Typography>
        <Typography variant='h6'>{error.message}</Typography>
      </DialogContent>
      <DialogActions>
        <Stack spacing={1} direction='row'>
          <Button variant='contained' onClick={handleCloseModal} size='small'>
            확인
          </Button>
          <CSVLink
            className='download-button'
            data={convertCsvFormat(routines, challengeId)}
            headers={routineCsvHeaders}
            filename={fileName}
          >
            데이터 다운로드
          </CSVLink>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
